import { batchDeleteFieldTemplates } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { BatchDeleteInput } from "db/definitions";
import { recordSentry } from "utils/recordSentry";

async function batchRemoveFieldTemplates(fieldTemplates: BatchDeleteInput[]): Promise<boolean> {
	if (fieldTemplates.length > 0) {
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchDeleteFieldTemplates,
				variables: { fieldTemplates },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			recordSentry({ error });
			return false;
		}
	}
	return true;
}

export default batchRemoveFieldTemplates;
